import React, { useEffect, useState } from "react";
import { Spinner, Stack, Thumbnail } from "@shopify/polaris";
import { useAppMutation } from "../../../../hooks/useAppMutation.js";
import { FileMinor, ImageMajor } from "@shopify/polaris-icons";

const ProductsList = ({ productsIds }) => {
  const [products, setProducts] = useState([]);

  const { isLoading, mutate } = useAppMutation({
    url: "/api/products/history",
    reactMutationOptions: {
      onSuccess(data) {
        setProducts(() => data.products);
      },
      onError(error) {
        // Handle error silently
      }
    }
  });

  useEffect(() => {
    setProducts([]);
    mutate({ productsIds });
  }, [productsIds]);


  return (
    isLoading
      ? <Stack distribution={"center"}><Spinner /></Stack>
      : <Stack vertical>
        {products.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
            <p><strong>No products found for this action history.</strong></p>
          </div>
        ) : (
          products.map(product => (
            <div key={product.id}>
              <Stack>
                <Thumbnail
                  source={product.featuredImage || ImageMajor}
                  alt={product.title}
                  size={"small"}
                />
                <span>{product.title}</span>
              </Stack>
            </div>
          ))
        )}
      </Stack>
  );
};

export default ProductsList;